import { render } from "./StationPack.vue?vue&type=template&id=60609120&scoped=true"
import script from "./StationPack.vue?vue&type=script&lang=js"
export * from "./StationPack.vue?vue&type=script&lang=js"

import "./StationPack.vue?vue&type=style&index=0&id=60609120&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60609120"]])

export default __exports__